export default [
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/pages/Dashboard')
  }
]
